export default __webpack_public_path__ + "static/hitech-algo-invest-2cd5991ba0101edf04280c5be02743cc.png";